import { render, staticRenderFns } from "./BrowserSupportNotification.vue?vue&type=template&id=cdbdf9ae&scoped=true&"
import script from "./BrowserSupportNotification.vue?vue&type=script&lang=js&"
export * from "./BrowserSupportNotification.vue?vue&type=script&lang=js&"
import style0 from "./BrowserSupportNotification.vue?vue&type=style&index=0&id=cdbdf9ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbdf9ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VIcon,VSnackbar})
